export default __webpack_public_path__ + "static/AntIcon113-d1c3327aea17a690083b0d9668e27527.png";